import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classNames from 'classnames';

import Page from '../../../page.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner';
import paymentPropTypes, {
    data as paymentDataPropTypes,
} from '../../../paymentPropTypes.js';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes.js';
import { approveDiscount } from '../../payment/paymentActions.js';
import DiscountDetails from '../../../resolution/discountDetails.jsx';

const DiscountSuggestedByBuyerDetails = ({ agreement, partner, payment }) => (
    <Page heading={`Venter på svar fra ${partner.name}`}>
        <div>
            <p>
                Du har foreslått et prisavslag på{' '}
                {formatOreToKroner(payment.discount)}. Hvis {partner.name}{' '}
                godkjenner forslaget, betaler du{' '}
                {formatOreToKroner(payment.amount)} for varen.
            </p>

            <DiscountDetails
                agreement={agreement}
                partner={partner}
                role="BUYER"
                discount={payment.discount}
                discountFee={agreement.fee - payment.fee}
            />
        </div>
    </Page>
);

DiscountSuggestedByBuyerDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

const DiscountSuggestedBySellerDetails = ({
    agreement,
    handleClickApproveDiscount,
    partner,
    payment,
}) => (
    <Page
        heading={`${partner.name} foreslår et prisavslag på ${formatOreToKroner(
            payment.data.discount
        )}.`}
    >
        <div>
            <p>
                Hvis du godtar forslaget, betaler du{' '}
                {formatOreToKroner(payment.data.amount)} for varen og{' '}
                {formatOreToKroner(payment.data.freight)} for frakt.
            </p>

            <DiscountDetails
                agreement={agreement}
                partner={partner}
                role="BUYER"
                discount={payment.data.discount}
                discountFee={agreement.fee - payment.data.fee}
            />

            <div className="centerify r-phl r-ptl">
                <button
                    disabled={payment.loading}
                    className={classNames('primary fullwidth r-mbm', {
                        inprogress: payment.loading,
                    })}
                    onClick={handleClickApproveDiscount}
                >
                    Godta prisavslag
                </button>

                <div className="r-mvl">
                    <Link to="/losning/noe-er-galt-med-varen" className="pam">
                        Foreslå en annen løsning
                    </Link>
                </div>
            </div>
        </div>
    </Page>
);

DiscountSuggestedBySellerDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    handleClickApproveDiscount: PropTypes.func.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
};

const DiscountSuggestedDetails = ({
    agreement,
    handleClickApproveDiscount,
    partner,
    payment,
}) => {
    if (payment.data.performedBy === 'SELLER') {
        return (
            <DiscountSuggestedBySellerDetails
                agreement={agreement}
                handleClickApproveDiscount={handleClickApproveDiscount}
                partner={partner}
                payment={payment}
            />
        );
    }

    return (
        <DiscountSuggestedByBuyerDetails
            agreement={agreement}
            partner={partner}
            payment={payment.data}
        />
    );
};

DiscountSuggestedDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    handleClickApproveDiscount: PropTypes.func.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        itemId: state.safeTrade.itemId,
        itemType: state.safeTrade.itemType,
        partner: state.partner,
        payment: state.payment,
    };
}

const mapDispatchToProps = { handleClickApproveDiscount: approveDiscount };

function mergeProps(stateProps, dispatchProps, ownProps) {
    const { itemType, itemId, partner } = stateProps;

    return {
        ...ownProps,
        ...stateProps,
        handleClickApproveDiscount: () =>
            dispatchProps.handleClickApproveDiscount({
                itemType,
                itemId,
                partnerId: partner.id,
            }),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
    DiscountSuggestedDetails
);



// WEBPACK FOOTER //
// ./safeTrade/buyer/resolution/statusDetails/discountSuggestedDetails.jsx